import { searchKey } from "./towerFormat";

// Texto que Excel tomaría como fórmula (=, +, -, @, tab o retorno al inicio):
// se le antepone un apóstrofo. Los números se dejan como están.
function neutralizeFormula(value: unknown): string {
  const text = value === null || value === undefined ? "" : String(value);
  if (typeof value === "number" || !/^[=+\-@\t\r]/.test(text)) return text;
  return `'${text}`;
}

// Mismo formato que la descarga de Envíos (pages/Deliveries.tsx): coma,
// valores entre comillas y BOM para que Excel respete los acentos.
export function toCsv(headers: string[], rows: unknown[][]): string {
  const cell = (value: unknown) => `"${neutralizeFormula(value).replace(/"/g, '""')}"`;
  return "\ufeff" + [headers, ...rows].map((row) => row.map(cell).join(",")).join("\n");
}

export function downloadCsv(filename: string, headers: string[], rows: unknown[][]) {
  const url = URL.createObjectURL(new Blob([toCsv(headers, rows)], { type: "text/csv;charset=utf-8;" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

// Nombre de archivo sin caracteres raros: torre-<parte>-<fecha>.csv
export function csvName(part: string, date: string) {
  const slug = searchKey(part).toLowerCase().replace(/ /g, "-");
  return `torre-${slug || "envios"}-${date}.csv`;
}
